(() => {
  if (customElements.get('sisu-postcode-checker')) return;
  const storageKey = 'sisu-delivery-postcode';
  class SisuPostcodeChecker extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.input = this.querySelector('[data-input]');
      this.button = this.querySelector('[data-check]');
      this.result = this.querySelector('[data-result]');
      if (!this.input || !this.button || !this.result) return;
      this.postcodes = new Set((this.dataset.postcodes || '').split(/[\s,;]+/).filter(value => /^[0-9]{4}$/.test(value)));
      if (!this.postcodes.size) return;
      this.ready = true;
      this.querySelector('[data-controls]').hidden = false;
      this.button.addEventListener('click', () => this.check());
      this.input.addEventListener('keydown', event => {
        if (event.key === 'Enter') {
          event.preventDefault();
          event.stopPropagation();
          this.check();
        }
      });
      this.input.addEventListener('input', () => {
        this.result.hidden = true;
        this.result.textContent = '';
        this.removeAttribute('data-state');
        this.input.removeAttribute('aria-invalid');
        try { sessionStorage.removeItem(storageKey); } catch (_) {}
      });
      try {
        const saved = sessionStorage.getItem(storageKey);
        if (/^[0-9]{4}$/.test(saved || '')) {
          this.input.value = saved;
          this.check();
        }
      } catch (_) {}
    }
    check() {
      const postcode = this.input.value.trim();
      const valid = /^[0-9]{4}$/.test(postcode);
      const available = valid && this.postcodes.has(postcode);
      const state = !valid ? 'invalid' : available ? 'available' : 'unavailable';
      this.setAttribute('data-state', state);
      this.input.setAttribute('aria-invalid', String(!valid));
      this.result.textContent = this.dataset[state].replace('__SISU_POSTCODE__', postcode);
      this.result.hidden = false;
      if (valid) {
        this.input.value = postcode;
        try { sessionStorage.setItem(storageKey, postcode); } catch (_) {}
      } else {
        this.input.focus();
      }
    }
  }
  customElements.define('sisu-postcode-checker', SisuPostcodeChecker);
})();
